import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { FileAttachmentUUID } from '../../../fileAttachmentsTypes';

import {
  FETCH_FILE_ATTACHMENT_DOWNLOAD_URLS_QUERY,
  FetchFileAttachmentDownloadUrlsQueryResponse
} from '../../../queries/fetchFileAttachmentDownloadUrls';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';
import { useShowFileAttachment } from '../../../hooks/useShowFileAttachment';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

import { FileAttachmentCache } from '../../../FileAttachmentCache';

interface DownloadFileAttachmentSeparatelyButtonProps {
  className?: ClassName;
  fileAttachmentUuid: FileAttachmentUUID;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  togglePreventModalClose?: () => void;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadFileAttachmentSeparatelyButton({
  className,
  dataGa,
  fileAttachmentUuid,
  i18nText,
  icon,
  iconClassName,
  togglePreventModalClose,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadFileAttachmentSeparatelyButtonProps & GADataType) {
  const { fileAttachmentLoading, refetchFileAttachment, fileAttachmentError } =
    useShowFileAttachment<FetchFileAttachmentDownloadUrlsQueryResponse>({
      cacheKey: FileAttachmentCache.downloadUrls(fileAttachmentUuid),
      options: {
        enabled: false,
        enabledPlaceholder: false
      },
      query: FETCH_FILE_ATTACHMENT_DOWNLOAD_URLS_QUERY,
      uuid: fileAttachmentUuid
    });

  useShowToastOnErrorChange({ error: fileAttachmentError });

  return (
    <DownloadUrlsModalButton<'fileAttachment'>
      className={className}
      dataGa={dataGa}
      disabled={fileAttachmentLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      itemClassName="file_attachment"
      refetchItemDownloadUrls={refetchFileAttachment}
      scope="fileAttachment"
      togglePreventModalClose={togglePreventModalClose}
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadFileAttachmentSeparatelyButton;
